import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { GAME_CARD_RATIO } from "../../../constants/gamePack";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    gap: theme.spacing.space8,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "-webkit-fill-available",
  },
  rootGame: {
    display: "flex",
    position: "relative",
    width: 150 / GAME_CARD_RATIO,
    height: 150,
    flexShrink: 0,
    borderRadius: 6,
  },
  title: {
    padding: `0 ${theme.spacing.space16}px`,
  },
  gameList: {
    display: "flex",
    gap: theme.spacing.space12,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollPaddingInline: `${theme.spacing.space16}px`,
    padding: `${theme.spacing.space6}px ${theme.spacing.space16}px`,
  },
  image: {
    width: "100%",
    height: "100%",
    borderRadius: 6,
  },
  loadingImage: {
    borderRadius: theme.radius.large,
  },
  inactive: {
    opacity: 0.4,
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
    // webOS 22 (Chromium <=87): outline ignores border-radius; box-shadow follows it
    "@supports not (aspect-ratio: 1 / 1)": {
      outline: "none",
      boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.80)",
    },
  },
  gameLoading: {
    display: "flex",
    gap: theme.spacing.space12,
  },
  gameLastActiveDot: {
    content: '""',
    position: "absolute",
    width: 12,
    height: 12,
    top: 4,
    right: 4,
    borderRadius: "50%",
    background: "#22c55e",
  },
  hourGlassBadge: {
    position: "absolute",
    top: theme.spacing.space4,
    right: theme.spacing.space4,
    width: 25,
    height: 25,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    color: "#FFFFFF",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.45)",
    background:
      "linear-gradient(rgba(38, 38, 38, 0.92), rgba(38, 38, 38, 0.92)) padding-box, linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.05) 100%) border-box",
    border: "1.5px solid transparent",
    backdropFilter: "blur(6px)",
  },
}));
